import moment from "moment";

export const tsToDate = (ts) => {
    return moment(ts).format('MMM Do YY')
}

export const tsToMonthYear = (ts) => {
    return moment(ts).format('MMMM YYYY')
}

export const getAgeFromDob = (dob) => {
    return moment().diff(dob, 'years')
}